/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { consts } from '@irian-ro/shared-components-module';
import { nestedTemplateFormsViewProviders } from './nested-template-forms-view-providers';
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';
import { IriroActionType } from '@irian-ro/util-table';
import { regexConstants } from './regex-constants';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export const constants = {
  ...consts,
  defaultStartTime: '00:00',
  businessHourStartTime: '08:00',
  defaultEndTime: '23:30',
  businessHourEndTime: '17:00',
  defaultDeadlineTime: '17:00',
  laptopSmallBreakpoint: 1024,
  laptopMediumBreakpoint: 1280,
  laptopLargeBreakpoint: 1440,
  tabletBreakpoint: 768,
  maxPackageCountLimit: 200,
  numberOfDaysForCalendarOffset: 2,
  terminalRowSize: '2rem ',
  splitDistanceArea: 50,
  currencyList: [
    { label: 'RON', value: 'RON' },
    { label: 'EUR (\u20AC)', value: 'EUR' },
    { label: 'USD ($)', value: 'USD' }
  ],
  eTransportCurrencyList: [
    { label: 'EUR (\u20AC)', value: 'EUR' },
    { label: 'USD ($)', value: 'USD' },
    { label: 'CHF (\u20A3)', value: 'CHF' },
    { label: 'GBP (\u20A4)', value: 'GBP' }
  ],
  cronExpressions: [
    { label: 'daily', value: '0 0 * * *' },
    { label: 'weekly', value: '0 0 * * 0' },
    { label: 'monthly', value: '0 0 1 * *' },
    { label: 'yearly', value: '0 0 1 1 *' }
  ],
  googleMapsCompletedOptions: {
    polylineOptions: {
      strokeColor: '#4caf50',
      strokeWeight: 7,
      strokeOpacity: 1.0,
      zIndex: 1000,
    },
    markerOptions: {
      icon: {
        url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
      },
      zIndex: 1000,
    },
  },
  companyTypeList: [
    { label: 'Client', value: CompanyType.customer },
    { label: 'Casa expeditii', value: CompanyType.forwarder },
    { label: 'Transportator', value: CompanyType.service_provider },
    { label: 'Client cu flota', value: CompanyType.customer_with_fleet }
  ],
  nestedTemplateFormsViewProviders: nestedTemplateFormsViewProviders,
  validationErrorsKeys: {
    differentTimeLimitError: 'differentTimeLimitError',
  },
  dynamicDialogBaseConfig: <DynamicDialogConfig>{
    width: '40vw',
    style: { 'min-height': '150px', 'max-height': '450px' },
    modal: true,
    closeOnEscape: true,
    dismissableMask: true,
    focusTrap: false,
    focusOnShow: false,
    breakpoints: {
      '1024px': '60vw',
      '640px': '80vw',
    },
  },
  regexConstants: regexConstants,
  daysOfWeek: <{ label: string; value: string }[]>[
    { label: 'Monday', value: 'MONDAY' },
    { label: 'Tuesday', value: 'TUESDAY' },
    { label: 'Wednesday', value: 'WEDNESDAY' },
    { label: 'Thursday', value: 'THURSDAY' },
    { label: 'Friday', value: 'FRIDAY' },
    { label: 'Saturday', value: 'SATURDAY' },
    { label: 'Sunday', value: 'SUNDAY' }
  ],
  defaultDatePattern: "YYYY-MM-DD",
  defaultDateAndTimePattern: "YYYY-MM-DDTHH:mm:SS",
  defaultTimezone: 'Europe/Bucharest',
};

export enum WellActionType {
  DETAILS,
  ARCHIVE,
  EXECUTIONS,
  START,
  STOP,
  TRIGGERCHAIN,
  TRIGGER,
  VIEW,
  ADD,
  EDIT,
  DELETE,
  TEMPLATE,
  ACCEPT,
  SELECT_ONE,
  ORDER_COMPLAINT,
  CREATE_FROM_EXISTING_ORDER,
  CREATE_SUPPLIER_ORDER_FROM_EXISTING,
  RESOLVE_COMPLAINT,
  FILTER_SAVE,
  TERRITORY_CHANGE,
  FAVOURITE_CHANGE,
  ORDER_STATUS_CHANGE,
  RESEND_EMAIL,
  TRACK_ORDER,
  UPDATE_ACCOUNT,
  REFRESH_LIST,
  RETRY,
  BLOCK,
  UNBLOCK,
}

export const ActionType = {
  ...WellActionType,

  ...IriroActionType,
};

export type ActionType = WellActionType | IriroActionType;
